<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Change bio</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || !canSave"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <Textarea v-model="bio" label="Bio" :disabled="loading" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Textarea, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import type { User } from '@/shared/graphql/legacy/generated'
import { useChangeBio } from './useChangeBio'

const { close } = useSheet()

const props = defineProps<{
  user: User
}>()

const { bio, loading, canSave, save } = useChangeBio(props.user)

const handleSave = async () => {
  if (await save()) close()
}
</script>
